import { ERROR_TYPES, IErrorContent, TErrorType } from './models';

export const DEFAULT_LINK = '/';
export const DEFAULT_LINK_TEXT = 'На главную';

/**
 * Ошибки для авторизованной и неавторизованной зоны
 */
export const ERROR_CONTENT: { [x in TErrorType]: IErrorContent } = {
  [ERROR_TYPES.BAD_REQUEST]: {
    title: ERROR_TYPES.BAD_REQUEST,
    header: 'Неправильные параметры',
    description: 'Вы можете написать нам на почту support@centra.ai или обратиться к менеджеру Centra',
  },
  [ERROR_TYPES.NOT_FOUND]: {
    title: ERROR_TYPES.NOT_FOUND,
    header: 'Страница не найдена',
    description: 'Она была перенесена, удалена или ее никогда не существовало',
  },
  [ERROR_TYPES.SERVER_ERROR]: {
    title: ERROR_TYPES.SERVER_ERROR,
    header: 'Упс. Что-то пошло не так',
    description:
      'Мы уже знаем о проблеме и скоро все починим. Вы можете написать нам на почту support@centra.ai или обратиться к менеджеру Centra',
  },
  [ERROR_TYPES.UNKNOWN]: {
    title: 'Ошибка',
    header: 'Упс. Что-то пошло не так',
    description:
      'Мы уже знаем о проблеме и скоро все починим. Вы можете написать нам на почту support@centra.ai или обратиться к менеджеру Centra',
  },
};
